import type { ListItemLabelUpdatePanelFragment } from "../../client/generated";
import { useTranslation } from "react-i18next";
import { AttributePanel } from "../AttributePanel";
import { useDeleteListItemLabelFromPanelMutation } from "../../client/generated";

type Props = {
  fragment: ListItemLabelUpdatePanelFragment;
};

export function ListItemLabelUpdatePanel({ fragment }: Props) {
  const { t } = useTranslation();
  const [deleteAttribute] = useDeleteListItemLabelFromPanelMutation();

  const onSave = async () => {};

  const onDelete = async () => {
    await deleteAttribute({
      variables: { attributeId: fragment.id },
      update(cache) {
        const id = cache.identify(fragment);
        cache.evict({ id });
        cache.gc();
      },
    });
  };

  return (
    <AttributePanel
      title={t("ListItemLabelUpdatePanel.title")}
      onSubmit={onSave}
      onDelete={onDelete}
    />
  );
}
